/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';

import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';

import styles from '../../../../ActionDrawer.module.scss';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';
import type Form from '../../../../../../forms/_.extend';

type TypeProps = {
  manufacturer: Object,
  form: Form,
  actionDrawerStore: TypeActionDrawerStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class ArchiveManufacturerForm extends React.Component<*> {
  render(): ?React.Node {
    const { t }: TranslatorProps = this.props;
    const { form }: TypeProps = this.props;
    const manufacturer: Object = this.props.manufacturer;

    if (!manufacturer) {
      return null;
    }

    const manufacturerDetails: Array<Array> = [
      [t('general:manufacturers.labels.name'), manufacturer.name],
      [t('general:manufacturers.labels.code'), manufacturer.code],
      [t('general:manufacturers.labels.short_code'), manufacturer.short_code],
      [t('general:manufacturers.labels.key_oem'), manufacturer.key_oem ? 'Yes' : 'No'],
      [],
      [t('general:products.labels.temporary'), manufacturer.product_pending_count],
      [t('general:products.labels.approved'), manufacturer.product_approved_count],
      [t('general:products.labels.not_approved'), manufacturer.product_not_approved_count],
    ];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:manufacturers.labels.details')}
          >
            <ActionDrawerTable data={manufacturerDetails} />
          </ActionDrawerBlock>
          <ActionDrawerBlock
            gutters={true}
            heading={t('general:manufacturers.reasons.why_archive')}
          >
            <ElectroTextField
              field={form.$('archiveManufacturerForm.reason')}
              props={{
                multiline: true,
                rows: 3,
              }}
              margin="none"
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.archive')} />
      </React.Fragment>
    );
  }
}
